module.exports = __webpack_public_path__ + "img/no_chat.3ddcccb0.svg";